import { render } from "./RutasCobrosCrear.vue?vue&type=template&id=50f7200c"
import script from "./RutasCobrosCrear.vue?vue&type=script&lang=js"
export * from "./RutasCobrosCrear.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wServer\\app-pagos-elroble\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__